// @flow
import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import SwitchFooterContainer from '../../../components/SwitchFooterContainer';

import Landing from '../../../modules/landing/Landing';

import useStyles from './LandingView.styles';
import { withRouter } from 'react-router-dom';

interface Props {
  backendSupport: string[];
  createNewConversation: Function;
  history: Object;
  user: Object;
  waitForConnectResponse: boolean;
}

const LandingView = ({ backendSupport, createNewConversation, history, user, waitForConnectResponse }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {!backendSupport.includes('connectRequest') &&
        // eslint-disable-next-line
        (console.log('redirect to because backend does not support connect request') || 1) &&
        history.push('/download')}
      <Landing
        host={user && user.features && user.features['web-host']}
        onHost={createNewConversation}
        twilio={user && user.features && user.features.twilio}
      />
      {waitForConnectResponse && <CircularProgress color="secondary" />}
      <SwitchFooterContainer history={history} />
    </div>
  );
};

export default withRouter(LandingView);
